export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9726.5e02c5f4.jpg";